<template>
  <v-icon
    v-bind="$attrs"
    v-on="$listeners"
  >
    {{ icon }}
    <slot></slot>
  </v-icon>
</template>

<script>
export default {
  name: 'SGPIconComponent',

  props: {
    icon: {
      type: String,
      required: true,
      default: ''
    }
  }
}
</script>